import React, { useEffect, useState } from "react";
import styles from "./category.module.scss";
import {
  KoButton,
  KoLoader,
  KoModal,
  KoPagination,
  KoTable,

  KoForm,
  KoImage,
  KoTitle,
  KoText
} from "packages";
import ProductObject from "../constant";
import KoIcon from "@kwapio/icons";
import { OrdersAPI } from "../../../orders.service";
import KoToolBar from "shared/components/toolbar";
import ChildCategoryDetails from "./childCategoryDetails";
import SubCategoryForm from "./subCategoryForm";

const SubCategoryDetails = () => {

  // ✅ CREATE FORM INSTANCE PROPERLY
  const [form] = KoForm.useForm();

  const [isLoading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [childCategoryDetails, setChildCategoryDetails] = useState(false);
  const [childCategoryList, setchildCategoryList] = useState([]);
  const [createChildCategory, setCreateChildCategory] = useState(false);

  const [pagination, setPagination] = useState({
    size: 100,
    page: 1
  });

  useEffect(() => {
    getChildCategory();
  }, []);

  const onPagination = (page, size) => {
    setPagination({
      page,
      size,
      offset: (page - 1) * size
    });
  };

  const sanitizeRows = (rows = []) =>
    rows.map(item => ({
      ...item,
      image: item?.image?.url ?? "",
      createdAt: item?.createdAt ?? "",
      description: item?.description ?? "",
      name: item?.name ?? ""
    }));

  const getChildCategory = () => {
    setLoading(true);

    OrdersAPI.getCategory()
      .then(res => {
        const rows = Array.isArray(res?.categories) ? res.categories : [];
        setchildCategoryList(sanitizeRows(rows));
        setTotalCount(res?.totalCount ?? rows.length);
      })
      .catch(() => {
        setchildCategoryList([]);
        setTotalCount(0);
      })
      .finally(() => setLoading(false));
  };

  const handleFinish = (values) => {
    console.log("FORM SUBMITTED:", values);
    setCreateChildCategory(false);
  };

  return (
    <div className={styles.wrapper}>
      {isLoading && <KoLoader />}
      <div className={styles.bodyContent}>
        <div className={styles.CategoryDetails}>
          <div className={styles.CategoryDetailsImage}>
            <KoImage
              alt={"name"}
              src={"/images/mouse.png"}
              width={200}
              height={200}
              preview={false}
            />
          </div>
      
          <div className={styles.CategoryDetailsContent}>
            <div className={styles.productName}>
              <KoTitle level={4} text={"Mouse"} />
            </div>
      
            <div className={styles.row}>
              <div className={styles.rowcontent}>
                <KoIcon className={styles.icons} name={"ProcessingOutlined"} width={20} height={20} />
                <KoText  className={styles.title} text={"Product"} />
              </div>
              <KoText className={styles.value} level={5} text={"88"} />
            </div>
      
            <div className={styles.row}>
              <div className={styles.rowcontent}>
                <KoIcon className={styles.icons} name={"TotalStockOutlined"} width={20} height={20} />
                <KoText className={styles.title} text={"Stock"} />
              </div>
              <KoText
                level={5}
                className={styles.value}
                text={"812"}
              />
            </div>
      
            <div className={styles.row}>
              <div className={styles.rowcontent}>
                <KoIcon className={styles.icons} name={"OrderDescriptionOutlined"} width={20} height={20} />
                <KoText  className={styles.title} text={"Description"} />
              </div>
              <KoText
                className={styles.value}
                level={5}
                text={
                  "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
                }
              />
            </div>
      
            <div className={styles.row}>
              <div className={styles.rowcontent}>
                <KoIcon className={styles.icons} name={"OrderDateOutlined"} width={20} height={20} />
                <KoText className={styles.title} text={"Created"} />
              </div>
              <KoText
                level={5}
                className={styles.value}
                text={"14 January 2024, 10:00"}
              />
            </div>
          </div>
        </div>
        <div className={styles.CategoryTable}>
          <div className={styles.deletebtn}>
            <KoToolBar
              title=""
              search={{
                visible: true,
                onChange: () => {},
                placeholder: "Search by any parameter"
              }}
              buttonList={[
                {
                  label: "Create",
                  type: "primary",
                  icon: <KoIcon name="PlusOutlined" width={18} height={18} />,
                  onClick: () => setCreateChildCategory(true)
                }
              ]}
            />
          </div>

          <KoTable
            data={{
              columns: ProductObject.CAT_COLUMN,
              rows: childCategoryList
            }}
            onExtraClick={setChildCategoryDetails}
          />

          {/* DETAILS MODAL */}
          <KoModal
            title="Child Category Details"
            centered
            open={childCategoryDetails}
            onClose={() => setChildCategoryDetails(false)}
            width="90vw"
            footer={[
              <KoButton
                key="cancel"
                label="Cancel"
                onClick={() => setChildCategoryDetails(false)}
              />
            ]}
          >
            <ChildCategoryDetails />
          </KoModal>

          <KoModal
            title="Create Sub Category"
            centered
            open={createChildCategory}
            onClose={() => setCreateChildCategory(false)}
            width="30vw"
            footer={[
              <KoButton
                key="cancel"
                label="Cancel"
                onClick={() => setCreateChildCategory(false)}
              />,
              <KoButton
                key="create"
                type="primary"
                loading={isLoading}
                label="Create"
                onClick={() => form.submit()} // ✅ NOW WORKS
              />
            ]}
          >
            <SubCategoryForm
              form={form}
              handleFinish={handleFinish}
            />
          </KoModal>

          <KoPagination
            current={pagination.page}
            total={totalCount}
            pageSize={pagination.size}
            onChange={onPagination}
          />
        </div>
      </div>
    </div>
  );
};

export default SubCategoryDetails;
